{
    "ReporttypeDesktopwallboard": "Desktop Wallboard (sans licence)",
    "ReporttypeDashboard": "Tableau de bord",
    "ReporttypeActivecalllist": "Liste d'appels actifs (sans licence)",
    "ReporttypeHistoriccalllist": "Liste d'appels historiques",
    "ReporttypeUnreturnedlostcalls": "Appels perdus non retournés (sans licence)",
    "ReporttypeExtensionlist": "Liste des extensions (sans licence)",
    "ReporttypeAcdagentlist": "Liste des agents ACD (sans licence)",
    "ReporttypeHuntgrouplist": "Liste des groupes de chasse (sans licence)",
    "ReporttypeTrunkinterfacelist": "Liste des interfaces trunk",
    "ReporttypeCallsbytelno": "Appels par numéro de téléphone",
    "ReporttypeCallsbyddi": "Appels par DDI (sans licence)",
    "ReporttypeCallsbyhalfhourinterval": "Appels par intervalle de ½ heure",
    "ReporttypeCallsbyhalfhourplusday": "Appels par ½ heure + jour",
    "ReporttypeCallsbyday": "Appels par jour",
    "ReporttypeCallsbyweek": "Appels par semaine",
    "ReporttypeCallsbymonth": "Appels par mois",
    "ReporttypeCallsbyaccountcode": "Appels par code de compte (sans licence)",
    "ReporttypeAcddndactivitylog": "Journal d'activité ACD \/ DND (sans licence)",
    "ReporttypeAcsnacodeusage": "Utilisation du code ACS N\/A (sans licence)",
    "ReporttypeExternalcontent": "Contenu externe (via URL)",
    "ReporttypeUnlicensedformattingstring": "|1 (sans licence)",
    "GroupLive": "Événements en direct",
    "GroupEntity": "Entité",
    "GroupLogs": "Bûches",
    "GroupInterval": "Intervalle",
    "GroupMisc": "Divers",
    "NAME": "ReportTypes"
}